import { requestApi } from 'api/api'
import { ApiBaseUrl, ApiEndpoint } from 'constants/Api'
import { DynamicFieldsSections } from 'constants/dynamicFields'
import {
  DynamicDocumentPayload,
  DynamicFieldsData,
  DynamicFieldsSection,
} from 'types/dynamicFields'

export const getDynamicFields = (sections: DynamicFieldsSection[]): Promise<DynamicFieldsData> => {
  return requestApi({
    url: ApiEndpoint.DYNAMIC_FORMS,
    baseUrl: ApiBaseUrl.ACCOUNTS,
    method: 'GET',
    params: {
      section: sections?.join(),
    },
  })
}

export const submitDynamicDocuments = (document: DynamicDocumentPayload): Promise<void> => {
  return requestApi({
    url: ApiEndpoint.DYNAMIC_FORMS,
    baseUrl: ApiBaseUrl.ACCOUNTS,
    method: 'PUT',
    data: {
      section: DynamicFieldsSections.DOCUMENTS,
      fields: [document],
    },
  })
}
